import { HTMLTagRegEx } from "../../../../constants";
import { TValidator } from "../../../wizard/types";
import { detailsConfig } from "../../constants";
import { ServiceDetailType } from "../../types";

const requiredTypes: ServiceDetailType[] = detailsConfig
  .filter((config) => config.isRequired)
  .map((config) => config.type);

const validator: TValidator = async ({ values }) => {
  const errors: { [key: string]: any } = {
    details: {},
  };

  if (!values.serviceType) {
    errors.serviceType = "This field is required";
  }

  if (!values.countries || values.countries.length === 0) {
    errors.countries = "This field is required";
  }

  const details = values?.details || {};

  requiredTypes.forEach((type) => {
    if (
      !details[`type_${type}`] ||
      !details[`type_${type}`].replace(HTMLTagRegEx, "").trim().length
    ) {
      errors.details[`type_${type}`] = "This field is required.";
    }
  });

  if (
    Object.keys(errors).length > 1 ||
    Object.keys(errors.details).length > 0
  ) {
    throw errors;
  }
};

export default validator;
